/* Shared collection/search buying: each form owns one explicit stock variant. */
(function () {
  'use strict';
  function limits(ceiling, minimum, increment, inCart) {
    var min = Math.max(increment, Math.ceil((minimum - inCart) / increment) * increment);
    var max = Math.max(0, Math.floor((ceiling - inCart) / increment) * increment);
    return { min: min, max: max, step: increment };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { limits: limits }; return;
  }
  function notice(form, text) {
    var node = form.querySelector('[data-row-notice]');
    node.style.color = '';
    node.textContent = text; node.hidden = !text;
  }
  function sync(form, cart, reset) {
    var inCart = Number(form.dataset.inCart || 0);
    if (cart) {
      inCart = cart.items.reduce(function (sum, item) {
        return sum + (String(item.variant_id) === form.dataset.variant ? item.quantity : 0);
      }, 0);
      form.dataset.inCart = inCart;
    }
    var range = limits(Number(form.dataset.ceiling), Number(form.dataset.minimum), Number(form.dataset.increment), inCart);
    var input = form.querySelector('[name="quantity"]');
    input.min = range.min; input.max = range.max; input.step = range.step;
    if (reset) input.value = range.min;
    var quantity = Number(input.value);
    var blocked = range.max < range.min || form.dataset.busy === '1' || form.dataset.uncertain === '1';
    input.disabled = blocked;
    form.querySelector('[data-row-add]').disabled = blocked;
    form.querySelector('[data-row-step="-1"]').disabled = blocked || quantity <= range.min;
    form.querySelector('[data-row-step="1"]').disabled = blocked || quantity + range.step > range.max;
    var price = Number(form.dataset.netPrice);
    var breaks = JSON.parse(form.dataset.breaks || '[]');
    breaks.sort(function (a, b) { return a.min - b.min; }).forEach(function (entry) {
      if (inCart + quantity >= entry.min) price = entry.price;
    });
    if (form.dataset.consumer === '1') price = Math.round(price * 1.2);
    form.querySelector('[data-option-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
      { style: 'currency', currency: form.dataset.currency }).format(price / 100);
    if (range.max < range.min) notice(form, 'No further units available to add.');
    return range;
  }
  async function readCart(form) {
    var response = await fetch(form.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
    var cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Unable to check your cart. Please try again.');
    return cart;
  }
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-row-toggle]');
    if (toggle) {
      event.preventDefault();
      var panel = toggle.closest('.prow').querySelector('[data-row-options]');
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      toggle.textContent = panel.hidden ? 'Choose options' : 'Hide options';
      if (!panel.hidden) {
        var forms = Array.from(panel.querySelectorAll('[data-row-cart]'));
        forms = forms.filter(function (form) { return !form.dataset.gradeKey; });
        forms.forEach(function (form) { sync(form, null, false); });
        if (forms.length) readCart(forms[0]).then(function (cart) {
          forms.forEach(function (form) { sync(form, cart, false); });
        }).catch(function () { /* Submission checks again before any write. */ });
      }
      return;
    }
    var step = event.target.closest('[data-row-step]');
    if (!step) return;
    var form = step.closest('[data-row-cart]');
    if (form.dataset.gradeKey) return;
    var input = form.querySelector('[name="quantity"]');
    var range = sync(form, null, false);
    input.value = Math.max(range.min, Math.min(range.max, Number(input.value || range.min) + Number(step.dataset.rowStep) * range.step));
    sync(form, null, false);
  });
  document.addEventListener('input', function (event) {
    var form = event.target.closest('[data-row-cart]');
    if (form && !form.dataset.gradeKey && event.target.name === 'quantity') sync(form, null, false);
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-row-cart]');
    if (!form || form.dataset.gradeKey) return;
    event.preventDefault();
    if (form.dataset.busy === '1' || form.dataset.uncertain === '1') return;
    var feedback = window.HciCartFeedback;
    if (!feedback || !feedback.begin(form)) return;
    var input = form.querySelector('[name="quantity"]');
    var quantity = Number(input.value);
    var button = form.querySelector('[data-row-add]');
    notice(form, '');
    form.dataset.busy = '1'; button.textContent = 'Adding…'; sync(form, null, false);
    var attempted = false;
    var added = false, confirmed = false;
    try {
      var range = sync(form, await readCart(form), false);
      if (!Number.isInteger(quantity) || quantity < range.min || quantity > range.max || (quantity - range.min) % range.step) {
        throw new Error(range.max < range.min ? 'No further units available to add.' : 'Choose a quantity between ' + range.min + ' and ' + range.max + ' in steps of ' + range.step + '.');
      }
      attempted = true;
      var response = await fetch(form.action + '.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.dataset.variant, quantity: quantity }] }) });
      if (!response.ok) {
        var data = await response.json();
        throw new Error(data.description || data.message || 'Unable to add this option. Please check availability.');
      }
      added = true;
      sync(form, await feedback.refresh(form.dataset.cartUrl), true);
      confirmed = true;
    } catch (error) {
      if (attempted) { form.dataset.uncertain = '1'; feedback.unknown(); }
      feedback.notice(form, added ? 'Added to your basket, but we could not refresh it. Check your basket before adding more.' :
        attempted ? 'We could not confirm the addition. Check your basket before trying again.' : error.message, attempted);
    } finally {
      form.dataset.busy = ''; button.textContent = 'Add to Cart'; feedback.end(); sync(form, null, false);
      if (confirmed) feedback.added(form, quantity);
    }
  });
  document.addEventListener('hci:cart-updated', function (event) {
    document.querySelectorAll('[data-row-cart]').forEach(function (form) {
      if (!form.dataset.gradeKey) sync(form, event.detail, false);
    });
  });
}());
